
































import { Component } from '@niknevis/vue-modules'
import { Prop } from 'vue-property-decorator'
import NewsForm from '@/modules/news/components/admin/NewsForm.vue'
import BaseButton from '@/modules/shared/components/shared/kit/BaseButton.vue'
import Modal from '@/modules/common/dialog/components/shared/Modal.vue'
import { mixins } from 'vue-class-component'
import DialogMixin from '@/modules/common/dialog/mixins/DialogMixin'
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import AdminPredefinedAnswerForm from '@/modules/predefined-answer/components/admin/AdminPredefinedAnswerForm.vue'
import {
  PredefinedAnswerUpdateUseCase
} from '@/modules/predefined-answer/use-cases/admin/predefined-answer-update-use.case'
import { PredefinedAnswerResourceModel } from '@/modules/predefined-answer/models/predefined-answer-resource.model'

@Component({
  components: { AdminPredefinedAnswerForm, Modal, NewsForm, BaseButton }
})
export default class AdminPredefinedAnswerUpdateDialog extends mixins<DialogMixin>(DialogMixin) {
  constructor(
    private readonly useCase: PredefinedAnswerUpdateUseCase
  ) {
    super()
  }

  $refs: {
    dialog: QDialog
  }

  @Prop() predefinedAnswer!: PredefinedAnswerResourceModel
  private editBtnLabel: string = 'ذخیره تغییرات'
  private editCancelBtnLabel: string = 'انصراف'
  private dialogModel = true

  onSubmit() {
    this.useCase.execute(this.predefinedAnswer.id, this.predefinedAnswer).then(() => {
      if (this.useCase.isSuccess) this.dialogModel = false
    })
  }

}
